import React from "react";
import {
  HashRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import "./index.css";
import NavBar from "./components/NavBar/NavBar";
import P4Auth from "./components/Auth/P4Auth";
import P4UserProfile from "./components/Profile/P4UserProfile";
import MetersListPage from "./components/Meters/MetersListPage";
import MetersAddPage from "./components/Meters/MetersAddPage";
import PaymentPage from "./components/Payment/PaymentPage";
import P4ChangePassword from "./components/PasswordChange/PasswordChange";
import MeterDetailPage from "./components/Meters/MeterDetailPage";
import HomePage from "./components/Home/HomePage";
import TrusteeDashboard from "./components/TrusteeDashboard/TrusteeDashboard";
import WalletPage from "./components/WalletView/WalletPage";
//import AdminMetersPage from "./components/Admin/AdminMetersPage";
//import AdminLogin from "./components/Admin/AdminLogin";
import WalletsListPage from "./components/WalletView/WalletListPage";
import PublicMeterKwhAndToken from "./components/PublicMeter/PublicMeter";
import MyNotificationsPage from "./components/Notifications/MyNotificationsPage";
import MeterSettings from "./components/Meters/MeterSettings";
import { AuthProvider } from "./components/context/AuthContext";
import VerifyPasswordChange from "./components/PasswordChange/VerifyPasswordChange";
import ForgotPassword from "./components/PasswordChange/ForgotPassword";
import ResetPassword from "./components/PasswordChange/ResetPassword";

const IS_HOME_DOMAIN = /(^|\.)p4power\.co\.za$/i.test(window.location.hostname);
const PORTAL_BASE =
  process.env.REACT_APP_PORTAL_BASE || "https://simplix.co.za";

const PrivateRoute = ({ element }) => {
  const location = useLocation();
  const token =
    localStorage.getItem("auth_token") || localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  const mustCompleteProfile =
    localStorage.getItem("profile_incomplete") === "true" ||
    localStorage.getItem("tcs_accepted") !== "true";

  if (mustCompleteProfile && location.pathname !== "/profile") {
    return <Navigate to="/profile" replace />;
  }

  return element;
};

const AdminRoute = ({ element }) => {
  const token = localStorage.getItem("admin_token");
  return token ? element : <Navigate to="/admin/login" replace />;
};

function Layout({ children }) {
  const location = useLocation();
  const onRoot = location.pathname === "/" || location.hash === "#/";
  const hideNav = IS_HOME_DOMAIN || onRoot;
  return (
    <>
      {!hideNav && <NavBar />}
      {children}
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <HashRouter>
        <Layout>
          <Routes>
            <Route
              path="/meter-services"
              element={<PublicMeterKwhAndToken />}
            />
            {IS_HOME_DOMAIN ? (
              <>
                <Route
                  path="/"
                  element={<HomePage portalBase={PORTAL_BASE} />}
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </>
            ) : (
              <>
                <Route
                  path="/"
                  element={<HomePage portalBase={PORTAL_BASE} />}
                />
                <Route path="/login" element={<P4Auth mode="login" />} />
                <Route path="/register" element={<P4Auth mode="register" />} />
                <Route path="/change-password" element={<P4ChangePassword />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route
                  path="/verify-password-change"
                  element={<VerifyPasswordChange />}
                />
                <Route
                  path="/profile"
                  element={<PrivateRoute element={<P4UserProfile />} />}
                />
                <Route
                  path="/meters"
                  element={<PrivateRoute element={<MetersListPage />} />}
                />

                <Route
                  path="/wallets"
                  element={<PrivateRoute element={<WalletsListPage />} />}
                />

                <Route
                  path="/notifications"
                  element={<PrivateRoute element={<MyNotificationsPage />} />}
                />

                <Route
                  path="/meters/add"
                  element={<PrivateRoute element={<MetersAddPage />} />}
                />

                <Route
                  path="/payment"
                  element={<PrivateRoute element={<PaymentPage />} />}
                />

                <Route
                  path="/meters/:meterId"
                  element={<PrivateRoute element={<MeterDetailPage />} />}
                />
                <Route
                  path="/meters/:meterId/settings"
                  element={<PrivateRoute element={<MeterSettings />} />}
                />

                <Route
                  path="/accounts/:accountId/wallet"
                  element={<PrivateRoute element={<WalletPage />} />}
                />
                <Route
                  path="/trustee-dashboard"
                  element={<PrivateRoute element={<TrusteeDashboard />} />}
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </>
            )}
          </Routes>
        </Layout>
      </HashRouter>
    </AuthProvider>
  );
}
